export default function initMenu(): void {
  Alpine.data('menu', () => ({
    searchActive: false,
    sideNavOpen: false,

    init(): void {
      const handleOutsideClick = (event: MouseEvent): void => {
        if (event.target === this.$refs.backdrop) {
          this.sideNavOpen = false;
        }
      };
      this.$watch('searchActive', () => this.$root.classList.toggle('search-active'));
      this.$watch('sideNavOpen', (newValue) => {
        this.$root.classList.toggle('side-nav-active');
        if (newValue) {
          this.$refs.sideMenu.addEventListener('click', handleOutsideClick);
        } else {
          this.$refs.sideMenu.removeEventListener('click', handleOutsideClick);
        }
      });
    },
    toggleSearch(): void {
      this.searchActive = !this.searchActive;
    },
    toggleSideNav(): void {
      this.sideNavOpen = !this.sideNavOpen;
    },
  }));
}
